import React, { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import SEO from '../../components/SEO';
import NavExpander from '../../containers/NavExpander';
import ToolTips from '../../containers/ToolTips';
import Recirc from '../../components/Recirc';
import styles from './page.css';
import PageContent from './PageContent';
import SubmissionForm from '../../components/SubmissionForm';

const Issue = ({
  path,
  header,
  title,
  description,
  content,
  footer,
  recircPost,
  themeClass,
  themeColors,
  artwork,
  topLeftArtwork,
  bottomRightArtwork,
}) => {
  const contentRef = useRef(null);

  const setTheme = () => {
    const contentEl = contentRef.current;

    if (contentEl && themeColors) {
      contentEl.style.setProperty('--primary', themeColors['primary_color']);
      contentEl.style.setProperty('--secondary', themeColors['secondary_color']);
      contentEl.style.setProperty('--text-color', themeColors['text-color']);
      contentEl.style.setProperty('--recirc', themeColors['recirc_color']);
    }
  };

  useEffect(() => {
    setTheme();
  }, []);

  return (
    <div className={styles.page}>
      <SEO title={title} description={description} path={path} />
      <NavExpander>
        <section className={styles.wrapper}>
          <div ref={contentRef} className={`${styles.content} ${themeClass}`}>
            {artwork && artwork}
            {topLeftArtwork && (
              <img className={styles.topLeftArtwork} src={topLeftArtwork} alt="" />
            )}
            {bottomRightArtwork && (
              <img className={styles.bottomRightArtwork} src={bottomRightArtwork} alt="" />
            )}
            <ToolTips>
              <PageContent header={header} footer={footer} content={content} />
              {path === '/questions' && <SubmissionForm />}
            </ToolTips>

            {recircPost && (
              <Recirc
                subtitle="Next Issue:"
                title={recircPost.title.replace('&#038;', '&')}
                link={recircPost.path}
              />
            )}
          </div>
        </section>
      </NavExpander>
    </div>
  );
};

Issue.propTypes = {
  path: PropTypes.string.isRequired,
  header: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  footer: PropTypes.string,
  recircPost: PropTypes.object,
  themeClass: PropTypes.string.isRequired,
  themeColors: PropTypes.object,
  artwork: PropTypes.any,
  topLeftArtwork: PropTypes.string,
  bottomRightArtwork: PropTypes.string,
};

export default withRouter(Issue);
